// src/App.js
import "./App.css";
import { ToastContainer } from "react-toastify";
import { RouterProvider } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
// import "react-datepicker/dist/react-datepicker.css"; // optional: keep if using datepicker
import router from "./routes/Routes"; // adjust path/casing to your project
import Loader from "./components/Loader";  // adjust path

function App() {
  useEffect(() => {
    const handleRouteChange = () => {
      window.scrollTo(0, 0);
    };
    
    // Listen for route changes
    const unsubscribe = router.subscribe(() => {
      handleRouteChange();
    });
    
    return () => unsubscribe();
  }, []);

  return (
    <div className="App">
      <ToastContainer
        limit={1}
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {/* Global loader — should be connected to redux or accept global props */}
      <Loader />

      {/* Your router component (should export a RouterProvider or <Routes/Routes> element) */}
     {/* Render RouterProvider (router is the object) */}
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
